import euLogo from '../assets/images/eulogo.png';
import hamagLogo from '../assets/images/logo-hamag.png';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl mb-4 text-yellow-500">Xemtio d.o.o</h3>
            <p className="text-gray-400 mb-4">
              Namještaj po mjeri za vaš savršeni dom. Kvaliteta, preciznost i posvećenost u svakom detalju.
            </p>
          </div>

          <div>
            <h4 className="text-lg mb-4 text-yellow-500">Brzi linkovi</h4>
            <ul className="flex space-x-4 md:grid md:grid-cols-2 md:justify-items-start md:w-fit md:space-x-0 md:gap-x-4 lg:flex lg:space-x-2 text-gray-400">
              <li className='w-fit'>
                <button
                  onClick={() => document.getElementById('usluge')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Usluge
                </button>
              </li>
              <li className='w-fit'>
                <button
                  onClick={() => document.getElementById('galerija')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Galerija
                </button>
              </li>
              <li className='w-fit'>
                <button
                  onClick={() => document.getElementById('o-nama')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  O nama
                </button>
              </li>
              <li className='w-fit'>
                <button
                  onClick={() => document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          <div>
            <div className="rounded-lg inline-block">
              <div className="flex flex-col gap-3 items-center">
                <img src={euLogo} alt="Europski fondovi" className='w-48' />
                <img src={hamagLogo} alt="Hamag bicro" className='w-48' />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Xemtio d.o.o. Sva prava pridržana.</p>
        </div>
      </div>
    </footer>
  );
}
